export const DATE_FORMAT_INPUT = 'DD-MM-YYYY';
export const DATE_FORMAT_PLACEHOLDER = 'DD-MM-AAAA';
